/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ConvertToObserveFunction
 * 
 * @format
 */

'use strict';

/**
 * Converts a FetchFunction into an ObserveFunction for use by RelayNetwork.
 */
function convertFetch(fn) {
  return function fetch(operation, variables, cacheConfig, uploadables) {
    return require('./RelayObservable').from(fn(operation, variables, cacheConfig, uploadables));
  };
}

/**
 * Converts a SubscribeFunction into an ObserveFunction for use by RelayNetwork.
 */
function convertSubscribe(fn) {
  return function subscribe(operation, variables, cacheConfig) {
    return require('./RelayObservable').fromLegacy(function (observer) {
      return fn(operation, variables, cacheConfig, observer);
    });
  };
}

module.exports = {
  convertFetch: convertFetch,
  convertSubscribe: convertSubscribe
};


//////////////////
// WEBPACK FOOTER
// ./~/relay-runtime/lib/ConvertToObserveFunction.js
// module id = 1655
// module chunks = 0